(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/analytics-customevent/assets/javascripts/custom-events.js') >= 0) return;  svs.modules.push('/components/components/analytics-customevent/assets/javascripts/custom-events.js');
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

svs.components = svs.components || {};
svs.components.analytics = svs.components.analytics || {};
svs.core = svs.core || {};
svs.core.analytics = svs.core.analytics || {};
svs.core.analytics.adl = svs.core.analytics.adl || {};
var logger = new svs.core.log.Logger('svs.analytics-event.CustomEvents');
var VALID_TARGETS = ['adobe', 'gtm'];
var validTargets = function validTargets(targets) {
  for (var i = 0; i < targets.length; i++) {
    if (VALID_TARGETS.indexOf(targets[i]) < 0) {
      throw new Error("invalid target ".concat(targets[i]));
    }
  }
};
var CustomEvent = function () {
  function CustomEvent(targets, event, data) {
    _classCallCheck(this, CustomEvent);
    if (this.constructor === CustomEvent) {
      throw new Error("Baseclass can't be instantiated.");
    }
    validTargets(targets);
    this.targets = targets;
    this.event = event;
    this.data = data;
  }
  _createClass(CustomEvent, [{
    key: "gtmOutput",
    get: function get() {
      logger.debug('To use GTM you must implement data format');
      return undefined;
    }
  }, {
    key: "adobeOutput",
    get: function get() {
      return this.data;
    }
  }, {
    key: "track",
    value: function track() {
      var msg = new svs.core.log.Message(svs.core.log.MessageType.customEvent);
      msg.eventname = this.event;
      msg.eventData = JSON.stringify(this.data);
      svs.core.log.track('svs.components.analytics', msg);
      if (this.targets.indexOf('adobe') > -1) {
        var data = this.adobeOutput;
        if (data) {
          window.eddl.eddlPush(this.event, data);
          Object.assign(svs.core.analytics.adl.consent, data);
          window.adobeDataLayer.adlPush('consentChanged', {
            site: svs.core.analytics.adl.site,
            consent: svs.core.analytics.adl.consent,
            user: svs.core.analytics.adl.user,
            page: svs.core.analytics.adl.page
          });
        }
      }
      if (this.targets.indexOf('gtm') > -1) {
        var _data = this.gtmOutput;
        if (_data) {
          dataLayerPush(_data);
        }
      }
    }
  }]);
  return CustomEvent;
}();
svs.components.analytics.customEvents = CustomEvent;

 })(window);